import { api } from '../../libs/api'
import dateToDateString from '../../libs/date-to-date-string'

export default {
  namespaced: true,

  state: {
    index: [],
    errors: [],
    condition: {},
    modal: {
      showSearchConditionModal: false,
    },
  },
  getters: {
    humanizedIndex: (state, _a, _b, rootGetters) =>
      state.index.map(({ id, name, condition, updated_at: updatedAt }) => {
        const {
          mediaCd,
          prefectureCd,
          cityCd,
          workPlacePrefectureCd,
          workPlaceCityCd,
          industryCd,
          viewEndDate,
          acquisitionDate,
        } = condition

        return {
          id,
          name,
          media: rootGetters['master/translateList']('media', mediaCd),
          prefectures: rootGetters['master/translateList']('prefectures', prefectureCd),
          cities: rootGetters['master/translateList']('cities', cityCd),
          workPlacePrefectures: rootGetters['master/translateList']('prefectures', workPlacePrefectureCd),
          workPlaceCities: rootGetters['master/translateList']('cities', workPlaceCityCd),
          industries: rootGetters['master/translateList']('industries', industryCd),
          situation: rootGetters['master/translate']('postingSituations', viewEndDate),
          acquisitionDate: rootGetters['master/translate']('acquisitionDates', acquisitionDate),
          condition,
          updatedAt: dateToDateString(new Date(updatedAt)),
        }
      }),
    condition: state => state.condition,
    sending: state => state.modal.showSearchConditionModal,
    list: state => state.index.map(({ id, name }) => ({ id, name })),
  },
  mutations: {
    index: (state, index) => state.index = index,
    errors: (state, errors) => state.errors = errors,
    condition: (state, condition) => state.condition = condition,
    showSearchConditionModal: state => state.modal.showSearchConditionModal = true,
    hideSearchConditionModal: state => state.modal.showSearchConditionModal = false,
  },
  actions: {
    async fetchIndex ({ commit }) {
      try {
        commit('index', await api.fetchMySearchConditionIndex())
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async setConditions ({ commit }, { condition }) {
      commit('condition', condition)
    },
    async send ({ commit }, { name, condition, id }) {
      try {
        if (id) {
          await api.updateSearchCondition({
            id,
            name,
            condition,
          })
        } else {
          await api.createSearchCondition({
            name,
            condition,
          })
        }
      } catch (e) {
        commit('errors', e)
        return Promise.reject(e)
      }
    },
    async destroy ({ dispatch }, { id }) {
      try {
        await api.destroyMySearchCondition({ id })
        await dispatch('fetchIndex')
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/search-condition.js